var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysPromoCode = function SvgSysPromoCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M4.329.986v1.333M4.329 3.986v2M4.329 7.652v1.334M10.662 3.319 7.329 6.652"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.007 1.752V3.49a1.629 1.629 0 0 1 1.06 1.493 1.553 1.553 0 0 1-1.06 1.509c-.014.017 0 1.72 0 1.72s-.098.791.834.791l10.966.01a.774.774 0 0 0 .845-.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.646 8.248V6.51a1.629 1.629 0 0 1-1.06-1.493 1.552 1.552 0 0 1 1.06-1.51c.014-.016 0-1.72 0-1.72s.097-.79-.835-.79L1.846.988a.774.774 0 0 0-.845.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M7.662 4.319a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333ZM10.329 6.986a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334Z"
  })));
};
export default SvgSysPromoCode;